import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {User} from "@/util/User";
import {Store} from "@/enums/Store";
import {UserInterface} from "@/types/User";

@Module({
  namespaced: true
})
export default class InvoiceRecipient extends VuexModule {
  invoiceRecipient: UserInterface = User.create();
  hasForeignInvoiceRecipient = false;

  @Mutation
  SET_INVOICE_RECIPIENT(user: UserInterface) {
    this.invoiceRecipient = user;
  }

  @Mutation
  SET_HAS_FOREIGN_INVOICE_RECIPIENT(value: boolean) {
    this.hasForeignInvoiceRecipient = value;
  }

  @Action
  setInvoiceRecipient(id: string) {
    const {commit, rootGetters} = this.context;
    const invoiceRecipient = rootGetters[`${Store.MEMBER}/memberById`](id);

    if (invoiceRecipient) {
      commit('SET_INVOICE_RECIPIENT', invoiceRecipient)
    } else {
      commit('SET_INVOICE_RECIPIENT', User.create())
    }
  }

  @Action
  setHasForeignInvoiceRecipient(value: boolean){
    const {commit} = this.context;
    commit('SET_HAS_FOREIGN_INVOICE_RECIPIENT', value)
  }
}
